import React, { Suspense } from 'react'
import PageLoader from '../../component/Elements/pageLoader'
import { lazyWithRetry } from '../../helper/lazyWithRetry'

const PrinterConfig = lazyWithRetry(() => import(/* webpackChunkName: "printer-config" */'../../component/PrinterConfig'))

const PrinterConfigPage = React.memo(() => {
	return (
		<Suspense fallback={<PageLoader />}>
			<PrinterConfig />
		</Suspense>
	)
})

PrinterConfigPage.displayName = 'PrinterConfigPage'
export default PrinterConfigPage
